import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface OtherFinancialLiabilitiesInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function OtherFinancialLiabilitiesInternalControls({
  onBack,
  setActiveSection,
  controlsListSection,
}: OtherFinancialLiabilitiesInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Other Financial Liabilities"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}
